// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"251":"237dd6d5","544":"28f6d26e"}[chunkId] + ".css";
};